import { Selector } from '@ngrx/store';
import * as RouterStoreSelectors from './router.selector';

export const selectCurrentAclId: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('a');
